<template>
  <div class="rounded-md bg-grey-90 p-6 timberland:bg-brand-5">
    <p class="mb-3 title-3">
      {{ $t.reviewAiSummaryTitle }}
    </p>
    <div class="mb-4 flex items-center gap-2">
      <vf-icon name="stars" />
      <p>{{ $t.reviewAiSummaryGeneratedText }}</p>
    </div>
    <p class="body-3">
      <slot />
    </p>
  </div>
</template>
